import Utils from "../misc/Utils";

class Player{
    constructor(id) {
        this.player = this.initVideoJS(id);
        this.$player = jQuery(this.player.el());
        this.cookie_name_volume = "volume_level";
        this.cookie_name_muted = "volume_muted";
        this._double_clicked = 0;
        this.hasChromeCast = false;
        this.skipBtn = {mode:null, dblClick:null};
        this.setupPlayerVolume();
        this.initPlayerEvents();
        this.setupExtraComponents();
        this.setupComponentsEvents();
        this.setupVastAd();
        this.setupChromeCast();
    }

    static set castSession(session){
        Player._castSession = session;
    }
    static get castSession(){
        return Player._castSession;
    }
    static get players(){
        if(typeof this._players === 'undefined'){
            this._players = {};
        }
        return this._players;
    }
    static set players(player){
        this._players = player;
    }

    static getPlayer(id){
        try{
            if(typeof Player.players[id] === 'undefined'){
                Player.players[id] = new Player(id);
            }
            return Player.players[id];
        }catch(e){
            return false;
        }
    }
    reloadPlayer(src, type){
        this.player.reset();
        if(typeof type === 'undefined'){
            type = 'video/mp4';
        }
        this.player.src([
            {type: type, src: src}
        ]);
        this.player.play().catch(() => { /* blaze it */});
    }
    initVideoJS(id){
        return videojs(id, {
            'fluid': true,
            controlBar: {
                children: [
                    "playToggle",
                    "volumeMenuButton",
                    "progressControl",
                    "currentTimeDisplay",
                    "fullscreenToggle"
                ]
            },
            plugins: {
                hotkeys: {
                    volumeStep: 0.1,
                    seekStep: 5,
                    enableModifiersForNumbers: false
                },
            }
        });
    }

    setupPlayerVolume() {
        let volumeLevel = 0.5;
        let isMuted = false;
        let cookie_value_volume = Utils.getCookie(this.cookie_name_volume);
        let cookie_value_muted = Utils.getCookie(this.cookie_name_muted);
        if(cookie_value_volume !== null) {
            if(!isNaN(cookie_value_volume) && ("" !== cookie_value_volume) && (cookie_value_volume > 0)) {
                volumeLevel = parseFloat(cookie_value_volume);
            } else {
                Utils.removeCookie(this.cookie_name_volume);
            }
        }
        if(cookie_value_muted !== null) {
            if(cookie_value_muted === 'yes') {
                isMuted = true;
            } else if(cookie_value_muted === 'no') {
                isMuted = false;
            } else {
                Utils.removeCookie(this.cookie_name_muted);
            }
        }
        this.player.volume(volumeLevel);
        if(isMuted) {
            this.player.muted(true);
        }

    }
    initPlayerEvents() {
        this.player.on('volumechange', () => {
            let volume_level = this.player.volume();
            let volume_muted = this.player.muted();
            if(!volume_muted && (volume_level === 0)) {
                volume_muted = true;
                volume_level = 0.5;
            }
            Utils.setCookie(this.cookie_name_volume, volume_level, (24 * 30));
            if(volume_muted) {
                Utils.setCookie(this.cookie_name_muted, "yes", (24 * 30));
            } else {
                Utils.setCookie(this.cookie_name_muted, "no", (24 * 30));
            }
        });
    }
    setupExtraComponents() {
        this.$player.append(jQuery('<div data-skip="-5" class="vjs-skip-btn"><i class="fas fa-angle-double-left fa-3x"></i></div>'));
        this.$player.append(jQuery('<div data-skip="+5"  class="vjs-skip-btn" style="right:0;"><i class="fas fa-angle-double-right fa-3x"></i></div>'));
    }
    setupComponentsEvents() {
        let self = this;
        this.$player.on('click', '[data-skip]', function () {
            let $btn = jQuery(this);
            let skipVal = $btn.attr('data-skip');
            if (self.skipBtn.dblClick || self.skipBtn.mode) {
                if(self.skipBtn.mode){
                    clearTimeout(self.skipBtn.mode);
                }
                jQuery(this).addClass('show');
                self.skipBtn.mode = setTimeout(function () {
                    $btn.removeClass('show');
                    this.skipBtn.mode = null;
                    this.skipBtn.dblClick = null;
                }, 1000);
                self.player.currentTime(self.player.currentTime() + parseFloat(skipVal));
            }else {
                self.skipBtn.dblClick = setTimeout(function () {
                    self.skipBtn.dblClick = null;
                }, 250)
            }
        });
        this.$player.on('click', '.cast-button', () => {
            this.onCastStart();
        });
        this.$player.on('click touchstart','#crazyshit_video_html5_api',() => {
            if(this._double_clicked>0) {
                this.$player.find('.vjs-fullscreen-control').click();
                clearTimeout(this._double_clicked);
                this._double_clicked = 0;
            }else{
                this._double_clicked = setTimeout(() => {
                    this._double_clicked = 0;
                },500);
            }
        });
    }
    setupVastAd() {
        if(typeof window.hasVastAd === 'undefined' || !window.hasVastAd){
            return false;
        }
        this.player.vastClient({
            'adTagUrl': window.vast_ad_url,
            'playAdAlways': true,
            'vpaidFlashLoaderPath': window.vpaidFlashLoaderPath,
            'adsEnabled': true
        });
        if(window.vast_cookie_expiry) {
            this.player.on('vast.adStart', function() {
                Utils.setCookie(window.vast_cookie_name, "1", window.vast_cookie_expiry);
            });
        }
    };

    onRequestSessionSuccess(e) {
        if(!this.player.paused()){
            this.player.pause();
        }
        Player._castSession = e;
        jQuery('.cast-button').find('.icon-custom').addClass('active');
        let source = this.player.currentSource();
        let mediaInfo = new chrome.cast.media.MediaInfo(source.src);
        mediaInfo.contentType = source.type;
        let request = new chrome.cast.media.LoadRequest(mediaInfo);
        request.autoplay = true;
        Player._castSession.loadMedia(request);
    }
    onCastStart() {
        let $castIcon = this.$player.find('.cast-button .icon-custom');
        chrome.cast.requestSession(
            (e) => {
                this.onRequestSessionSuccess(e);
            },
            (e) => {
                if(e.code === 'cancel' && $castIcon.hasClass('active') && Player._castSession.status !== 'connected'){
                    jQuery('.cast-button').find('.icon-custom').removeClass('active');
                }
            });
    }
    setupChromeCast() {
        if(typeof chrome === 'undefined' || typeof chrome.cast === 'undefined') {
            return false;
        }
        let self = this;
        let $castBtn = jQuery('<button class="cast-button vjs-control vjs-button" type="button" style="display: none;"><i class="icon-custom cast"></i></button>');
        $castBtn.insertBefore(this.$player.find('.vjs-control-bar .vjs-fullscreen-control'));
        let sessionListener = function (e) {
            self._castSession = e;
        }
        let receiverListener = function (e) {
            self._castSession = e;
            if(e === 'available') {
                $castBtn.fadeIn(150);
            } else {
                $castBtn.fadeOut(150);
            }
        }
        let retries = 0;
        let retriesInterval = setInterval(() => {
            if(retries === 10) {
                clearInterval(retriesInterval)
            }
            if (chrome.cast.isAvailable && !this.hasChromeCast) {
                clearInterval(retriesInterval)
                let applicationID = chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID;
                let sessionRequest = new chrome.cast.SessionRequest(applicationID);
                let apiConfig = new chrome.cast.ApiConfig(sessionRequest, sessionListener, receiverListener);
                chrome.cast.initialize(apiConfig, function() {}, function() {});
                this.hasChromeCast = true;
            }
            retries++;
        }, 1000)
    };
}

export default Player;
